import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AppFooter from "../components/Footers/AppFooter";
import classes from "./styles/FileSystemPage.module.css";
import { useAppDispatch, useAppSelector } from "../app/hooks/hooks";
import { selectUser } from "../app/features/auth/authSlice";
import {
    useGetAllUserFilesQuery,
    useLoadIfcFileMutation,
} from "../app/services/files/files";
import FileList from "../components/FileSystem/FileList/FileList";
import FileSystemHeader from "../components/FileSystem/FileSystemHeader/FileSystemHeader";
import { ReactComponent as BimatterLogo } from "./styles/Images/bimatter_logo.svg";
import MenuButton from "../components/Buttons/MenuButton";
import MadeByBimatter from "../components/MadeByBimatter/MadeByBimatter";
import config from "../config";
import Alert from "../components/Alert/Alert";
import { setAlert } from "../app/features/alertSlice/alertSlice";
export interface SelectedState {
    [model_id: string]: number;
}
function FileSystemPage() {
    const currentUser = useAppSelector(selectUser);
    const [uploadFiles] = useLoadIfcFileMutation();

    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const files = useGetAllUserFilesQuery(currentUser?.id);

    const [selectedState, setSelectedState] = useState<SelectedState>({});
    useEffect(() => {
        sessionStorage.removeItem("model_paths");
    }, []);
    useEffect(() => {
        if (files.isSuccess && files.currentData) {
            for (const file of files.currentData) {
                if (file.progress !== 100 && files.currentData) {
                    setTimeout(() => {
                        try {
                            files.refetch();
                        } catch {}
                    }, 500);
                    break;
                }
            }
        }
        setSelectedState({});
    }, [files]);
    if (files.isLoading) {
        return <div>loading</div>;
    }
    const openCallback = () => {
        if (!Object.keys(selectedState).length) return;
        if (
            Object.values(selectedState).filter((p: number) => p !== 100).length
        ) {
            setAlert({
                message: "Some selected models not loaded",
                type: "error",
            });
            return;
        }
        const user_id = currentUser
            ? currentUser.id
            : localStorage.getItem("temporaryUserName");
        sessionStorage.setItem(
            "model_paths",
            JSON.stringify(
                Object.keys(selectedState).map(
                    (model_id) => `Users/${user_id}/${model_id}.min.bmt`
                )
            )
        );
        navigate("/viewer");
    };
    const openAllCallback = () => {
        if (!files.currentData || !files.currentData.length) return;
        if (files.currentData.filter((p) => p.progress !== 100).length) {
            setAlert({
                message: "Some selected models not loaded",
                type: "error",
            });
            return;
        }
        const user_id = currentUser
            ? currentUser.id
            : localStorage.getItem("temporaryUserName");
        sessionStorage.setItem(
            "model_paths",
            JSON.stringify(
                files.currentData.map(
                    (model) => `Users/${user_id}/${model.model_id}.min.bmt`
                )
            )
        );
        navigate("/viewer");
    };
    const uploadFileCallback = () => {
        if (
            files.currentData &&
            files.currentData.length > 4 &&
            currentUser?.id !== 1 &&
            currentUser?.id !== 2
        ) {
            setAlert({
                message: "The limit of models is exceeded!",
                type: "error",
            });
            return;
        }
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".ifc, .Ifc";
        input.style.display = "none";
        input.multiple = true;
        document.body.appendChild(input);
        input.onchange = (e) => {
            //@ts-ignore
            for (const file of e.target.files) {
                uploadFiles(file)
                    .unwrap()
                    .then(() => {
                        files.refetch();
                    });
            }

            input.remove();
        };
        input.click();
    };
    const shareLinkCallback = () => {
        if (!Object.keys(selectedState).length) return;
        if (
            Object.values(selectedState).filter((p: number) => p !== 100).length
        ) {
            setAlert({
                message: "Some selected models not loaded",
                type: "error",
            });
            return;
        }
        const user_id = currentUser
            ? currentUser.id
            : localStorage.getItem("temporaryUserName");
        const model_paths = JSON.stringify(
            Object.keys(selectedState).map(
                (model_id) => `Users/${user_id}/${model_id}.min.bmt`
            )
        );
        try {
            var textField = document.createElement("textarea");
            textField.innerText = `${
                process.env.NODE_ENV === "production"
                    ? config.CLIENT.split(`:${config.CLIENT_PORT}`)[0]
                    : config.CLIENT
            }/link/${btoa(model_paths)}`;
            document.body.appendChild(textField);
            textField.select();
            document.execCommand("copy");
            textField.remove();
            dispatch(
                setAlert({
                    message: "Link was copy to clipboard",
                    type: "success",
                })
            );
        } catch (err) {
            console.error(err);
            dispatch(
                setAlert({
                    message: "Error while creatin link!",
                    type: "error",
                })
            );
        }
    };
    return (
        <div className={classes.wrap}>
            <MadeByBimatter></MadeByBimatter>
            <BimatterLogo
                onClick={() => {
                    window.location.href = "https://www.bimatter.ru/";
                }}
                className={classes.logo}
            ></BimatterLogo>
            <FileSystemHeader
                uploadFileCallback={uploadFileCallback}
                openCallback={openCallback}
                openAllCallback={openAllCallback}
                shareLinkCallback={shareLinkCallback}
                selectedState={selectedState}
                refetch={files.refetch}
            ></FileSystemHeader>
            <div className={classes.buttons_wrap}>
                <MenuButton
                    onClick={() => {
                        navigate("/demo");
                    }}
                >
                    demo models
                </MenuButton>
            </div>
            {/* <button onClick={uploadFileCallback}>Upload file</button>
            <button onClick={openCallback}>Open</button>
            <button onClick={openAllCallback}>Open All</button> */}

            <FileList
                files={files.currentData}
                selectedState={selectedState}
                setSelectedState={setSelectedState}
                uploadFileCallback={uploadFileCallback}
                update={files.refetch}
            ></FileList>
            <Alert></Alert>
        </div>
    );
}

export default FileSystemPage;
